/**
 * Keep this third library in its own utils file to prevent be preloaded until needed.
 */
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

export const getUsablePhone = (phone, countryCode) => {
  let usablePhone;
  if (countryCode) {
    const countryCodeRegex = new RegExp(`^\\${countryCode}`);
    const matchingCodeArray = phone.match(countryCodeRegex);
    usablePhone = matchingCodeArray
      ? phone.replace(countryCodeRegex, '') //remove the country code matching the dropdown
      : phone.replace(/^\+\d+ /, ''); //remove country code not matching the dropdown
  } else {
    usablePhone = phone.replace(/^\+\d+ /, ''); //remove the country code not yet selected
  }
  //filter characters out in case any remain ex: +345 3534+34534+34 removes the additional + signs
  //and remove spaces
  const finalPhone = usablePhone.replace(/[^\d ()-]/g, '').trim();
  return finalPhone;
};

export const googlePhoneFormat = (
  inputName,
  phone,
  countryObj,
  setFieldValue
) => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  const phoneNumberWithoutCountryCode = getUsablePhone(
    phone,
    countryObj?.callingCode
  );
  const parsedRawNumber = phoneUtil.parseAndKeepRawInput(
    phoneNumberWithoutCountryCode,
    countryObj?.code
  );
  const formattedNumber = phoneUtil.format(
    parsedRawNumber,
    PhoneNumberFormat.INTERNATIONAL
  );
  setFieldValue(inputName, formattedNumber, false);
  return { phoneNumberWithoutCountryCode, parsedRawNumber, formattedNumber };
};

export const googlePhoneValidate = (
  inputName,
  translation,
  phone,
  countryObj,
  dropDownValidate,
  setFieldValue,
  setFieldError
) => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  try {
    const { parsedRawNumber } = googlePhoneFormat(
      inputName,
      phone,
      countryObj,
      setFieldValue
    );
    if (!phoneUtil.isValidNumberForRegion(parsedRawNumber, countryObj?.code)) {
      //invalid phone number
      throw new Error('invalid phone');
    }
    return;
  } catch {
    if (dropDownValidate) {
      //validate with dropdown
      setFieldError(inputName, translation);
      return;
    } else {
      //validate with phone field
      return translation;
    }
  }
};
